"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _underscore = require("underscore");
var _ = require("../..");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _SourceListItemBody = require("./SourceListItemBody.styled");
var _SourceListAudioFileItemBody = _interopRequireDefault(require("./SourceListAudioFileItemBody"));
var _SourceListVideoFileItemBody = _interopRequireDefault(require("./SourceListVideoFileItemBody"));
var _SourceListImageFileItemBody = _interopRequireDefault(require("./SourceListImageFileItemBody"));
var _SourceListCameraPresenterItemBody = _interopRequireDefault(require("./SourceListCameraPresenterItemBody"));
var _SourceListScreenPresenterItemBody = _interopRequireDefault(require("./SourceListScreenPresenterItemBody"));
var _SourceListMediaItemBody = _interopRequireDefault(require("./SourceListMediaItemBody"));
var _SourceListItemFocusMenu = _interopRequireDefault(require("./SourceListItemFocusMenu"));
var _SourceListPdfFileItemBody = _interopRequireDefault(require("./SourceListPdfFileItemBody"));
var _sourceTypeBodyCompon;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SourceListItemBody = function SourceListItemBody(_ref) {
  var loop = _ref.loop,
    live = _ref.live,
    hover = _ref.hover,
    source = _ref.source,
    isStaged = _ref.isStaged,
    isCameraOn = _ref.isCameraOn,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    attendeeReceivedFrame = _ref.attendeeReceivedFrame,
    onLoopToggleClicked = _ref.onLoopToggleClicked,
    onCameraToggleClicked = _ref.onCameraToggleClicked,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    onLiveClicked = _ref.onLiveClicked,
    onThumbnailReady = _ref.onThumbnailReady,
    onSourceStaged = _ref.onSourceStaged,
    onFeaturedToggleClicked = _ref.onFeaturedToggleClicked,
    onMuteToggleClicked = _ref.onMuteToggleClicked,
    onVolumeChanged = _ref.onVolumeChanged,
    onUploadClicked = _ref.onUploadClicked,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    isTooltipVisible = _ref.isTooltipVisible,
    toggleTooltipVisibilityOn = _ref.toggleTooltipVisibilityOn,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    onPdfAssignClicked = _ref.onPdfAssignClicked,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess,
    onSourceDeleted = _ref.onSourceDeleted,
    layout = _ref.layout;
  var _getComponent = getComponent(source.type),
    Component = _getComponent.component;
  var transcodingStatus = (0, _underscore.isObject)(source.value) && source.value.transcodingStatus;
  var canShowFocusMenu = (0, _react.useMemo)(function () {
    /** For media files */
    if ((0, _broadcastSourceHelper.isVideoSource)(source) && transcodingStatus) {
      return transcodingStatus === 'success';
    }
    if (_.DocSourceTypes.includes(source.type) && source.value && !source.value.url) return false;

    /** For speaker and screenshares */
    if ((0, _broadcastSourceHelper.isPresenterSource)(source)) return !source.isInitializing;
    return true;
  }, [source, transcodingStatus]);
  return _react["default"].createElement(_SourceListItemBody.RelativeContainer, {
    live: live,
    hover: hover,
    isStaged: isStaged
  }, _react["default"].createElement(Component, _objectSpread(_objectSpread({}, source), {}, {
    live: live,
    isCameraOn: isCameraOn,
    onThumbnailReady: onThumbnailReady,
    onUploadClicked: onUploadClicked,
    hovered: hover,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    onPresentationLoadSuccess: onPresentationLoadSuccess,
    onSourceDeleted: onSourceDeleted
  })), canShowFocusMenu && _react["default"].createElement(_SourceListItemFocusMenu["default"], {
    hovered: hover,
    source: source,
    onFeaturedToggleClicked: onFeaturedToggleClicked,
    onMuteToggleClicked: onMuteToggleClicked,
    loop: loop,
    onLoopToggleClicked: onLoopToggleClicked,
    onCameraToggleClicked: onCameraToggleClicked,
    isCameraOn: isCameraOn,
    isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
    live: live,
    isStaged: isStaged,
    onLiveToggleClicked: onLiveToggleClicked,
    onSourceStaged: onSourceStaged,
    attendeeReceivedFrame: attendeeReceivedFrame,
    onVolumeChanged: onVolumeChanged,
    onSourceSetToLive: onLiveClicked,
    isStagedSourcesActive: isStagedSourcesActive,
    isTooltipVisible: isTooltipVisible,
    toggleTooltipVisibilityOn: toggleTooltipVisibilityOn,
    user: user,
    viewPermissions: viewPermissions,
    onPdfAssignClicked: onPdfAssignClicked,
    layout: layout
  }));
};
SourceListItemBody.propTypes = {
  source: _propTypes["default"].object.isRequired,
  live: _propTypes["default"].bool,
  hover: _propTypes["default"].bool,
  isCameraOn: _propTypes["default"].bool,
  isStaged: _propTypes["default"].bool,
  loop: _propTypes["default"].bool,
  isMaximumCameraSourcesOn: _propTypes["default"].bool,
  attendeeReceivedFrame: _propTypes["default"].object,
  onThumbnailReady: _propTypes["default"].func,
  onUploadClicked: _propTypes["default"].func,
  onFeaturedToggleClicked: _propTypes["default"].func,
  onMuteToggleClicked: _propTypes["default"].func,
  onLoopToggleClicked: _propTypes["default"].func,
  onCameraToggleClicked: _propTypes["default"].func,
  onLiveToggleClicked: _propTypes["default"].func,
  onSourceStaged: _propTypes["default"].func,
  onVolumeChanged: _propTypes["default"].func,
  onLiveClicked: _propTypes["default"].func,
  isStagedSourcesActive: _propTypes["default"].bool,
  isTooltipVisible: _propTypes["default"].bool,
  toggleTooltipVisibilityOn: _propTypes["default"].func,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  onPdfAssignClicked: _propTypes["default"].func,
  onPresentationLoadSuccess: _propTypes["default"].func,
  onSourceDeleted: _propTypes["default"].func,
  layout: _propTypes["default"].string
};
var _default = exports["default"] = (0, _react.memo)(SourceListItemBody);
var sourceTypeBodyComponents = (_sourceTypeBodyCompon = {}, (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.AUDIO_FILE, _SourceListAudioFileItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.VIDEO_FILE, _SourceListVideoFileItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.IMAGE_FILE, _SourceListImageFileItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.PDF_FILE, _SourceListPdfFileItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.CAMERA_PRESENTER, _SourceListCameraPresenterItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.SCREEN_PRESENTER, _SourceListScreenPresenterItemBody["default"]), (0, _defineProperty2["default"])(_sourceTypeBodyCompon, _.MEDIA, _SourceListMediaItemBody["default"]), _sourceTypeBodyCompon);
var getComponent = function getComponent(type) {
  return {
    component: sourceTypeBodyComponents[type]
  };
};